// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/icon_accepted.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./img/icon_rejected.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.muutoshakemus__header {
  color: #000;
  font-weight: 700;
  margin: 0;
}
h1.muutoshakemus__paatos-status {
  color: #00516d;
  font-weight: 700 !important;
  font-size: 1.4rem !important;
}
h3.muutoshakemus__header {
  font-size: 1.2rem;
  margin: 1rem 0;
}
h4.muutoshakemus__header {
  font-size: 1rem;
}
.muutoshakemus-section {
  margin: 0 0 2rem;
}
.muutoshakemus-row {
  margin: 2rem 0;
}
.muutoshakemus-description-box {
  white-space: pre-wrap;
  border: 1px solid #eaeaea;
  padding: 0.75rem 1rem;
}
.muutoshakemus__paatos {
  border-left: 3px solid #00b5f0;
  padding-left: 1rem;
}
.muutoshakemus__paatos-status {
  position: relative;
  padding-left: 3rem;
}
.muutoshakemus__paatos-icon:before {
  position: absolute;
  content: "";
  height: 100%;
  width: 2rem;
  left: 0;
  top: 0;
  background-size: 2rem;
}
.muutoshakemus__paatos-icon--accepted:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%;
}
.muutoshakemus__paatos-icon--accepted_with_changes:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%;
}
.muutoshakemus__paatos-icon--rejected:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 50% 50%;
}
.muutoshakemus__project-end-row {
  display: flex;
}
.muutoshakemus__project-end-row div:not(:first-of-type) {
  margin-left: 1vw;
}
.muutoshakemus-notice {
  border: 1px solid #deb335;
  box-sizing: border-box;
  border-radius: 4px;
  color: #956a14;
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: -0.035em;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
}
.muutoshakemus__existing-hakemus__container {
  padding-left: 80px;
  display: flex;
  flex-direction: row;
}
.muutoshakemus__existing-hakemus__title {
  font-size: 19px;
  line-height: 27px;
  letter-spacing: -0.015em;
  flex-grow: 1;
}
.muutoshakemus__existing-hakemus__status {
  color: #00516d;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.035em;
}
.muutoshakemus__existing-hakemus__values {
  margin-right: 80px;
  flex-grow: 2;
}
`, "",{"version":3,"sources":["webpack://./soresu-form/web/va/MuutoshakemusValues.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,gBAAA;EACA,SAAA;AADF;AAIA;EACE,cAAA;EACA,2BAAA;EACA,4BAAA;AAFF;AAKA;EACE,iBAAA;EACA,cAAA;AAHF;AAMA;EACE,eAAA;AAJF;AAOA;EACE,gBAAA;AALF;AAQA;EACE,cAAA;AANF;AASA;EACE,qBAAA;EACA,yBAAA;EACA,qBAAA;AAPF;AAUA;EACE,8BAAA;EACA,kBAAA;AARF;AAWA;EACE,kBAAA;EACA,kBAAA;AATF;AAaE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,qBAAA;AAXJ;AAgBE;EACE,qEAAA;AAdJ;AAmBE;EACE,qEAAA;AAjBJ;AAsBE;EACE,qEAAA;AApBJ;AAwBA;EACE,aAAA;AAtBF;AAqBA;EAII,gBAAA;AAtBJ;AA0BA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;AAxBF;AA2BA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAzBF;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,YAAA;AA1BF;AA6BA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;AA3BF;AA8BA;EACE,kBAAA;EACA,YAAA;AA5BF","sourcesContent":["@import \"~soresu-form/web/form/style/variables.less\";\n\n.muutoshakemus__header {\n  color: #000;\n  font-weight: 700;\n  margin: 0;\n}\n\nh1.muutoshakemus__paatos-status {\n  color: #00516d;\n  font-weight: 700 !important;\n  font-size: 1.4rem !important;\n}\n\nh3.muutoshakemus__header {\n  font-size: 1.2rem;\n  margin: 1rem 0;\n}\n\nh4.muutoshakemus__header {\n  font-size: 1rem;\n}\n\n.muutoshakemus-section {\n  margin: 0 0 2rem;\n}\n\n.muutoshakemus-row {\n  margin: 2rem 0;\n}\n\n.muutoshakemus-description-box {\n  white-space: pre-wrap;\n  border: 1px solid #eaeaea;\n  padding: 0.75rem 1rem;\n}\n\n.muutoshakemus__paatos {\n  border-left: 3px solid @bright-blue;\n  padding-left: 1rem;\n}\n\n.muutoshakemus__paatos-status {\n  position: relative;\n  padding-left: 3rem;\n}\n\n.muutoshakemus__paatos-icon {\n  &:before {\n    position: absolute;\n    content: \"\";\n    height: 100%;\n    width: 2rem;\n    left: 0;\n    top: 0;\n    background-size: 2rem;\n  }\n}\n\n.muutoshakemus__paatos-icon--accepted {\n  &:before {\n    background: url(\"./img/icon_accepted.svg\") no-repeat 50% 50%;\n  }\n}\n\n.muutoshakemus__paatos-icon--accepted_with_changes {\n  &:before {\n    background: url(\"./img/icon_accepted.svg\") no-repeat 50% 50%;\n  }\n}\n\n.muutoshakemus__paatos-icon--rejected {\n  &:before {\n    background: url(\"./img/icon_rejected.svg\") no-repeat 50% 50%;\n  }\n}\n\n.muutoshakemus__project-end-row {\n  display: flex;\n\n  div:not(:first-of-type) {\n    margin-left: 1vw;\n  }\n}\n\n.muutoshakemus-notice {\n  border: 1px solid #deb335;\n  box-sizing: border-box;\n  border-radius: 4px;\n  color: #956a14;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  letter-spacing: -0.035em;\n  padding: 0.5rem 1rem;\n  margin-bottom: 1rem;\n}\n\n.muutoshakemus__existing-hakemus__container {\n  padding-left: 80px;\n  display: flex;\n  flex-direction: row;\n}\n\n.muutoshakemus__existing-hakemus__title {\n  font-size: 19px;\n  line-height: 27px;\n  letter-spacing: -0.015em;\n  flex-grow: 1;\n}\n\n.muutoshakemus__existing-hakemus__status {\n  color: @dark-blue;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.035em;\n}\n\n.muutoshakemus__existing-hakemus__values {\n  margin-right: 80px;\n  flex-grow: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
